import React, { Fragment } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { Container, Row, Col } from "react-bootstrap";
import "./CardGrid.css"
import Post from "./Post";
import Header from "./Header";
import LeftCard from "./LeftCard";
import Footer from "./Footer";

import "./bubble.css";
import {
	Button,
	Alert,
	Card,
	CardImg,
	CardGroup,
	CardBody,
	CardTitle,
	CardSubtitle,
	CardText,
} from "react-bootstrap";
import theme, { GlobalStyles } from './FilesUploderComponent/UI-Components/Theme'
import { ThemeProvider } from '@mui/material'
const DemoCards = () => (
	<ThemeProvider theme={theme}>
      <GlobalStyles/>
      <div className='fillOutPage property'>
		<Header />
        
		<main className="head">
			<Container className="content-container px-0">
                <CardGroup>
                <Card className={"card-grid"} >
                        <Card.Body>
                            <Card.Title><strong>Bhagavad Gita</strong></Card.Title>
                            <Card.Text>
                                <p>This is Demo of llama2:8b model in Ollama infrastructure with Chroma DB RAG implementation, This Application responds to questions on Bhagavad Gita</p>
                            </Card.Text>
                            <Button variant="primary" href="Gita" rel={"noopener noreferrer"}>
                                Click for Demo
                            </Button>
                        </Card.Body>
                    </Card>
                    <Card className={"card-grid"} >
                        <Card.Body>
                            <Card.Title><strong>HRChat</strong></Card.Title>
                            <Card.Text>
                                <p>This is a Demo of Human Resources information chat bot. This is based on finetuning GPT2 Large Language Model for Custom HR dataset. This Dataset includes any organization employee policies like working mode, holidays, etc., </p>
                            </Card.Text>
                            <Button variant="primary" href="HrChat" rel={"noopener noreferrer"}>
                                Click for Demo
                            </Button>
                        </Card.Body>
                    </Card>
                    </CardGroup>
                    <CardGroup>
                    <Card className={"card-grid"} >
                        <Card.Body>
                            <Card.Title><strong>Insurance Chat</strong></Card.Title>
                            <Card.Text>
                                <p>This is a Demo of Health Insurance information chat bot. This is based on finetuning GPT2 Large Language Model for Custom Employee Health Insurance dataset. This Dataset includes any organization employee policies related to Health Insurance </p>
                            </Card.Text>
                            <Button variant="primary" href="InsChat" rel={"noopener noreferrer"}>
                                Click for Demo
                            </Button>
                        </Card.Body>
                    </Card>
                    
                    <Card className={"card-grid"} >
                        <Card.Body>
                            <Card.Title><strong>Stock Sentiment</strong></Card.Title>
                            <Card.Text>
                                <p>This page is with information related Indian Stock Sentiment for particular day. This has been prepared by collecting latest information from various sources available online</p>
                            </Card.Text>
                            <Button variant="primary" href="/StockSentiment" rel={"noopener noreferrer"}>
                                Click for Demo
                            </Button>
                        </Card.Body>
                    </Card>
                </CardGroup>
                {/* <CardGroup>
                <Card className={"card-grid"} >
                        <Card.Body>
                            <Card.Title><strong>Ask Youtube</strong></Card.Title>
                            <Card.Text>
                                <p>This app Is to Ask Youtube, It searches proper youtube video and points to the precise location of the video as a high school Physics teacher</p>
                            </Card.Text>
                            <Button variant="primary" href="/YouSearch" rel={"noopener noreferrer"}>
                                Click for Demo
                            </Button>
                        </Card.Body>
                    </Card>
                    <Card>
                    <Card.Body>
                            <Card.Title><strong>Design</strong></Card.Title>
                            <Card.Text>
                                <p>This app reverse engineers the python code and provides the design of a given code.</p>
                            </Card.Text>
                            <Button variant="primary"  rel={"noopener noreferrer"} >
                                Coming Soon
                            </Button>
                            
                            
                        </Card.Body>
                    </Card>
                </CardGroup> */}
			</Container>
		</main>
        <Footer className="footer" />
        </div>
  </ThemeProvider>
);

export default DemoCards;
